<template>
  <main>
    <section class="fk-contents">
    <h2 class="title-lv2" style="text-align: center;">「WFK-Club モバイルオーダー d払いミニアプリ」 利用規約</h2>
    <p class="comp-read" style="text-align: right;">2020.12.14</p>
    <p class="comp-read">ファーストキッチン株式会社(以下「当社」といいます)は、当社が提供する「WFK-Clubモバイルオーダーd払いミニアプリ」(以下「本システム」)のご利用規約(以下「本規約」)を以下の通り定めます。</p>
    <p class="title-lv3">ご利用条件</p>
    <p class="comp-read">本システムのご利用に先立ち、本規約をよくお読みいただき、本規約にご同意された場合のみご利用ください。<br>
本システムをご利用いただく場合は、本規約に同意されたものとみなしますので、ご同意されない場合、ご利用をお控えください。
本規約は、本システムの利用を希望した利用者(以下「利用者」)に適用されます。<br>
本システムの利用にかかる通信費用は、利用者が負担するものとします。<br>
本システムは、利用者本人が個人として使用する目的でのみ利用することができます。<br>
当社は、本システムのご利用条件を予告なしに変更することがありますので、最新の内容をご確認いただきますようお願い申し上げます。</p>
    <p class="title-lv3">著作権について</p>
    <p class="comp-read">公開された本システム内のコンテンツ(情報・資料・画像・音声・内容・商標・ロゴマーク等)及び本システムを構成するプログラム等に係る著作権および商標権、その他の知的財産権は、個別に特段の明示がない限り当社およびその関連会社、提携会社に帰属しており、各国の著作権法、各種条約およびその他の法律で保護されています。営利、非営利を問わず、法律上許容される範囲を超えて本システム内のコンテンツ(情報・資料・映像・音声・内容・商標・ロゴマーク等)を複製、転用、販売、あるいは、これらの情報の一部または全部を改変して転用、複製、アップロードなどをすることは一切禁止いたします。</p>
    <p class="title-lv3">掲載情報について</p>
    <p class="comp-read">本システムに情報を掲載する際には、細心の注意を払っておりますが、その内容の正確性・妥当性・ご利用目的への適合性・安全性については、一切保証いたしません。<br>
本システム上の情報・掲載内容は、予告なしに変更・削除することがあります。<br>
また、本システム自体の運営を中断または中止させていただくことがあります。なお、理由の如何を問わず、情報、掲載内容の変更・削除および本システムの運営の中断または中止によって生じるいかなる損害についても責任を負うものではありません。</p>
    <p class="title-lv3">禁止事項について</p>
    <p class="comp-read">本システムのご利用に際し、次の行為を禁止します。<br>
<br>
・第三者または当社の財産もしくはプライバシーを侵害する行為、または侵害するおそれのある行為。<br>
・第三者または当社に不利益もしくは損害を与える行為、またはそのおそれのある行為。<br>
・第三者または当社の名誉もしくは信用を毀損する行為、またはそのおそれのある行為。<br>
・公序良俗に反する行為、またはそのおそれのある行為。<br>
・犯罪行為または犯罪に結びつく行為、またはそのおそれのある行為。<br>
・他人の電話番号を登録する等、虚偽の申告、届出を行う行為。<br>
・その他、法律、法令または条例に違反する行為、またはそのおそれのある行為。<br>
・その他、当社が不適切と判断する行為。<br>
<br>
また、本システムの情報を使用されたこと、もしくはご使用になれなかったこと、また本システムをご利用になったことにより生じるいかなる損害についても責任を負うものではありません。</p>
    <p class="title-lv3">引用・リンクについて</p>
    <p class="comp-read">本システムの情報から引用、もしくは本システムへリンクを張っている第三者のリンクサイト(以下「リンクサイト」)に掲載されている情報については、それぞれリンクサイトの責任で管理されるものであり、当社の管理下にあるものではありません。<br>
従いまして、リンクサイトの利用に当たりましてはそれぞれの利用条件に従ってください。<br>
当社は、リンクサイトの内容につきまして何ら保証するものではなく、またその利用に伴う一切の損害について責任を負いません。<br>
また、別段の明記がない限り、リンクサイトまたはその運営者と当社との間に何ら提携関係等特段の関係があることを意味するものではありません。</p>
    <p class="title-lv3">免責事項について</p>
    <p class="comp-read">本システムのご利用は、皆様の各自の責任において行われるものとします。<br>
本システムのご利用に際し、発生した直接・間接の損失・損害に対し、当社はいかなる責任も負いません。</p>
    <p class="title-lv3">法準拠および管轄裁判所について</p>
    <p class="comp-read">本システムのご利用ならびに本ご利用条件の解釈および適用は、他に別段の定めのない限り、日本国法に準拠するものとします。<br>
また、本システムの利用に関わるすべての紛争については、他に別段の定めのない限り、東京地方裁判所を第一審専属管轄裁判所とします。</p>
    <p class="title-lv3">【附則】</p>
    <p class="comp-read">このご利用規約は、2020年 1月 1日から適用します。</p>
      <p class="mod-form-btn btn-back"><a href="#" class="btn-base" :class="Agreed ? ['btn-negative', 'btn-quit'] : 'btn-main'" @click.prevent="goTop">{{text.GoTop}}</a></p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import DirectStoreAccessMixin from '@/mixins/DirectStoreAccessMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
import {get, isEmpty} from 'lodash'
export default {
  name: 'FKMOUserPolicy',
  mixins: [ CommonMixin, DirectStoreAccessMixin, DisplayErrorMixin ],
  data () {
    return {
      text: {
        GoTop: null
      },
      Agreed: false
    }
  },
  methods: {
    goTop: async function () {
      const self = this
      try {
        if (!this.Agreed) {
          // 同意済みをサーバに送る
          const res = await self.callApi('DcmUserInfoUpdate', { user_policy_flag: true })
          if (get(res, 'data.result', true)) {
            this.$store.commit('setUserPolicyAgreed', true)
          } else {
            this.errorFromApi(res.data.errorCode, res.data.error)
            this.$store.commit('setUserPolicyAgreed', false)
          }
        }
      } catch (error) {
        this.errorFromAxios(error)
        this.$store.commit('setUserPolicyAgreed', false)
      } finally {
        this._transition()
      }
    },
    _transition: function () {
      if (!isEmpty(sessionStorage.getItem('directStoreCode'))) {
        // 店舗ダイレクトジャンプ
        this.$router.push({ name: 'ReceiveMethod' })
      } else {
        // 店舗コード指定なし
        this.$router.push({ name: 'Index' })
      }
    },
    checkFirstTime: async function () {
      this.Agreed = this.$store.getters.userPolicyAgreed
      try {
        if (this.Agreed === null) {
          // APIを叩いて同意済みかどうかを確認する
          const res = await this.callApi('DcmUserInfoGet', {})
          if (get(res, 'data.result', true)) {
            this.$store.commit('setUserPolicyAgreed', get(res, 'data.value.user_policy_flag', 'false'))
          } else {
            this.errorFromApi(res.data.errorCode, res.data.error)
            this.$store.commit('setUserPolicyAgreed', false)
          }
        }
      } catch (error) {
        this.errorFromAxios(error)
        this.$store.commit('setUserPolicyAgreed', false)
      }
    },
    initView: function () {
      this.Agreed = this.$store.getters.userPolicyAgreed
      this.text.GoTop = this.Agreed ? this.$i18n.t('OrderHistory.GoTop') : this.$i18n.t('UserPolicy.Agree')
    }
  },
  // onload
  beforeMount () {
    this.checkFirstTime()
  },
  mounted () {
    this.initView()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserPolicy.vue